import Extend from 'flarum/common/extenders';
import User from 'flarum/common/models/User';
import ProfilePage from './components/ProfilePage';
export default [new Extend.Model(User) //
.attribute('ignored').hasMany('ignoredUsers').attribute('canBeIgnored'), new Extend.Routes() //
.add('user.ignoredUsers', '/ignoredUsers', ProfilePage)];